import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from 'components/DoorControllerModelSelector/style'
import { CSSTransition } from 'react-transition-group'
import Fuse from 'fuse.js'
import ModelList from 'components/DoorControllerModelSelector/ModelList'
import ModelDetails from 'components/DoorControllerModelSelector/ModelDetails'
import ChangeModelWarning from 'components/DoorControllerModelSelector/ChangeModelWarning'
import { addExpansionControllerAction, changeDoorControllerModelAction } from 'actions/entityActions'
import { updateUiAction } from 'actions/uiActions'
import { currentDoorControllerSelector, doorControllerUsagesSelector, expansionControllerParentModelNameSelector,
  compatibleExpansionControllerModelsSelector } from 'selectors/components'
import getNewDeviceLocation from 'helpers/accessControl/getNewDeviceLocation'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'

const mapStateToProps = state => {
  return {
    doorController: currentDoorControllerSelector(state),
    usages: doorControllerUsagesSelector(state),
    models: compatibleExpansionControllerModelsSelector(state),
    parentModelName: expansionControllerParentModelNameSelector(state),
    map: state.map.ref
  }
}

class ExpansionControllerModelSelector extends React.Component {
  constructor(props) {
    super(props)
    const { doorController: { isExpansion, model: { id } }, models } = this.props

    this.anchorRef = null
    this.models = models.map(model => {
      return {
        ...model,
        trimmedText: model.text.replace(/\s|\\|\)|\(|\[|-/g, ''),
        trimmedModel: model.model.replace(/\s|\\|\)|\(|\[|-/g, '')
      }
    })

    const options = {
      threshold: 0.22,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      shouldSort: true,
      includeScore: true,
      keys: [{
        name: 'trimmedModel',
        weight: 0.9
      }, {
        name: 'trimmedText',
        weight: 0.1
      }]
    }
    this.fuse = new Fuse(this.models, options)

    this.state = {
      models: this.models,
      selectedModel: isExpansion ? this.models.find(m => m.id === id) : null,
      showChangeWarning: false,
      search: ''
    }
  }

  setModel = selectedModel => this.setState({ selectedModel })

  searchModels = search => {
    const sanitizedSearch = search.replace(/\s|\\|\)|\(|\[|-/g, '')

    let models = this.models

    if (complement(isEmpty)(sanitizedSearch)) {
      models = this.fuse.search(sanitizedSearch).map(r => r.item)
    }

    this.setState({
      search,
      models: models,
      selectedModel: null
    })
  }

  changeModelAction = (model, anchorRef) => {
    const { doorController: { id, isExpansion, location, expansionHeadingCounter }, map, usages,
      addExpansionControllerAction, changeDoorControllerModelAction, updateUiAction } = this.props

    if (!isExpansion) {
      const expansionLocation = getNewDeviceLocation(map, location, expansionHeadingCounter, 0.65)

      addExpansionControllerAction(id, expansionLocation, model)
      return updateUiAction({ modal: null })
    }

    if (Object.keys(usages).some(limitType => usages[limitType] > model.limits[limitType])) {
      this.anchorRef = anchorRef
      return this.setState({ showChangeWarning: true })
    }

    changeDoorControllerModelAction(id, model, true)
    updateUiAction({ modal: null })
  }

  confirmWarning = _ => {
    const { closeWarning, state: { selectedModel }, props: { doorController: { id, location }, changeDoorControllerModelAction, updateUiAction } } = this

    changeDoorControllerModelAction(id, selectedModel, true)
    closeWarning()
    updateUiAction({ modal: null })
  }
  closeWarning = _ => this.setState({ showChangeWarning: false })

  render() {
    const { setModel, changeModelAction, confirmWarning, closeWarning, anchorRef, searchModels,
      state: { models, selectedModel, showChangeWarning, search },
      props: { doorController: { isExpansion }, parentModelName, usages, permalink, classes } } = this

    return (
      <div className={classes.modelSelector}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            onChange={({ target: { value } }) => searchModels(value)}
            value={search}
            placeholder={`Search expansion controllers compatible with ${parentModelName}...`}
            type='text'
          />
        </div>
        <div className={classes.columnWrapper}>
          <ModelList
            models={models}
            selectedModel={selectedModel}
            setModel={setModel}
            usages={usages}
            recentModels={[]}
            favoriteModels={[]}
            search={search}
            selectedManufacturer={null}
            expansionSelector
            addingExpansion={!isExpansion}
          />
          <ModelDetails
            selectedModel={selectedModel}
            usages={usages}
            changeModelAction={changeModelAction}
            permalink={permalink}
            modelCount={models.length}
            expansionSelector
            addingExpansion={!isExpansion}
          />
        </div>
        <CSSTransition
          in={showChangeWarning}
          timeout={200}
          classNames={{ enter: classes.alertEnter, enterActive: classes.alertEnterActive, exit: classes.alertExit, exitActive: classes.alertExitActive }}
          unmountOnExit
        >
          <ChangeModelWarning
            anchorRef={anchorRef}
            confirm={confirmWarning}
            close={closeWarning}
          />
        </CSSTransition>
      </div>
    )
  }
}
export const ExpansionControllerModelSelectorConfig = { width: '850px', title: 'Select Expansion Controller Model' }
export default connect(mapStateToProps, { addExpansionControllerAction, changeDoorControllerModelAction, updateUiAction })(injectSheet(style)(ExpansionControllerModelSelector))



// WEBPACK FOOTER //
// ./src/components/ExpansionControllerModelSelector/index.js